import $ from 'jquery';
import { getCounties } from 'scripts/components/aktiv/aktiv-property-search';
import { getMunicipalities } from 'scripts/components/aktiv/aktiv-property-search';
import { getCityAreas } from 'scripts/components/aktiv/aktiv-property-search';
import { formatNumberWithThousandSeparator } from 'scripts/tools/formatting';

const any = (list, element, name) => {
  for (let i = 0; i < list.length; i++) {
    if (list[i][name] === element) {
      return true;
    }
  }
  return false;
};

const setSliderLabels = (sliderId, values, formatter) => {
  const value1 = formatter ? formatter(values[0]) : values[0];
  const value2 = formatter ? formatter(values[1]) : values[1];

  let labelText = `${value1} - ${value2}`;
  if (values[1] === $(sliderId).data('slider').max) {
    labelText = labelText + '+';
  }
  $(`${sliderId}-label`).text(labelText);
};

const bindSliderLabel = (sliderId, formatter) => {
  $(sliderId).on('slide', (e) => {
    const values = e.value;
    setSliderLabels(sliderId, values, formatter);
  });
};

const initSliderLabels = (sliderId, formatter) => {
  const values = $(sliderId).data('slider').value;
  setSliderLabels(sliderId, values, formatter);
};

const initSliders = (input, model) => {
  const values = model[input.name];
  const $slider = $(input.element);
  const max = $slider.data('slider').max;
  const begin = values.begin && values.begin !== 'undefined' ? values.begin : 0;
  const end = values.end && values.end !== 'undefined' ? values.end : max;
  $slider.slider('setValue', [begin, end]);
};

export const setUpSliderLabel = (input, model, formatter) => {
  initSliders(input, model);
  initSliderLabels(input.element, formatter);
  bindSliderLabel(input.element, formatter);
};

export const initRadiobox = (input, model) => {
  const currentSearhTerms = model[input.name];
  const radioboxes = $(input.element);
  const value = currentSearhTerms.begin && currentSearhTerms.begin !== 'undefined' ? currentSearhTerms.begin : 'all';

  for (let i = 0; i < radioboxes.length; i++) {
    const $radiobox = $(radioboxes[i]);
    if ($radiobox.attr('value') === value) {
      $radiobox.parent().addClass('active');
    }
  }
};

const toggleCheckbox = (checkbox, checkboxValues, currentSearhTerms) => {
  const check = checkboxValues.filter(t => currentSearhTerms.indexOf(t) !== -1).length > 0;
  $(checkbox).prop('checked', check);
};

export const initCheckboxes = (input, model) => {
  const checkboxes = $(input.element);
  const currentSearhTerms = model[input.name];
  if (currentSearhTerms) {
    const currentSearhTermsArray = currentSearhTerms.split(',');
    for (let i = 0; i < checkboxes.length; i++) {
      const checkbox = checkboxes[i];
      const checkboxValues = $(checkbox).attr('value').split(',');
      toggleCheckbox(checkbox, checkboxValues, currentSearhTermsArray);
    }
  }
};

export const clearDropdown = (dropdown, model) => {
  $(dropdown.element).empty();
  model.set(dropdown.name, undefined);
};

export const disableDropdown = (dropdown, model, option = true) => {
  $(dropdown.element).prop('disabled', option);
};

const iterateDropDowns = (dropdowns, func, model) => {
  Object.values(dropdowns).forEach(dropdown => func(dropdown, model));
};

export const disableDropdowns = (dropdowns, model) => {
  iterateDropDowns(dropdowns, disableDropdown, model);
};

export const clearDropDowns = (dropdowns, model) => {
  iterateDropDowns(dropdowns, clearDropdown, model);
};

const generateOption = (id, name, geoId) => {
  return (id === geoId) ?
    `<option value=${id} selected="selected">${name}</option>` :
    `<option value=${id}>${name}</option>`;
};

const buildDropdown = (input, options, defaultText, selected) => {
  $(input.element).html(`<option value="" ${selected && 'selected="selected'}">${defaultText}</option>`);
  $(input.element).append(options);
};

export const initCityAreas = (municipalityId, cityAreaId, inputs, model, translations) => {
  getCityAreas(municipalityId).then(object => {
    const foundCityAreas = object.customFilters && object.customFilters.length > 0;
    if (foundCityAreas) {
      const selected = any(object.customFilters, cityAreaId, 'customFilterId');
      const options = object.customFilters.map((customFilter) => generateOption(customFilter.customFilterId, customFilter.customFilterName, cityAreaId));
      buildDropdown(inputs.cityArea, options, translations.velgBydel, selected);
    }
    disableDropdown(inputs.cityArea, model, !foundCityAreas);
  });
};

export const initMunicipality = (countyId, geoMunicipalityId, inputs, model, translations) => {
  getMunicipalities(countyId).then(municipalities => {
    const foundMunicipalities = municipalities && municipalities.length > 0;
    const singleMuncipality = municipalities && municipalities.length === 1;
    const selectedGeoMunicipalityId = singleMuncipality ? municipalities[0].geoMunicipalityId : geoMunicipalityId;

    if (foundMunicipalities) {
      const selected = any(municipalities, selectedGeoMunicipalityId, 'geoMunicipalityId');
      const options = municipalities.map(municipality => generateOption(municipality.geoMunicipalityId, municipality.municipalityName, selectedGeoMunicipalityId));
      buildDropdown(inputs.municipality, options, translations.velgKommune, selected);
      if (selected) initCityAreas(selectedGeoMunicipalityId, model.cityArea, inputs, model, translations);
    }
    disableDropdown(inputs.municipality, model, !foundMunicipalities || singleMuncipality);
  });
};

export const initCounties = (geoCountyId, inputs, model, translations) => {
  getCounties().then(counties => {
    const selected = any(counties, geoCountyId, 'geoCountyId');
    const options = counties.map(county => generateOption(county.geoCountyId, county.countyName, geoCountyId));
    buildDropdown(inputs.county, options, translations.velgFylke, selected);
    if (selected) initMunicipality(geoCountyId, model.municipality, inputs, model, translations);
  });
};

export const onSliderChange = (event, input, model) => {
  const values = event.value;
  const begin = values[0];
  let end = values[1];
  if (end === $(input.element).data('slider').max) {
    end = undefined;
  }
  model.setRange(input.name, begin, end);
};

const filter = (element, separator = '') => {
  return $(element)
    .filter((i, el) => { return el.checked; })
    .map((i, el) => { return el.value; })
    .toArray()
    .join(separator);
};

export const onRadiobuttonChange = (input, model) => {
  const val = filter(input.element);

  if (val === '5') {
    model.setRange(input.name, 5, undefined);
  } else if (val === 'all') {
    model.setRange(input.name, undefined, undefined);
  } else {
    model.setRange(input.name, val, val);
  }
};

export const onDropdownChange = (input, model, event, dropdownProperties, inputs, translations) => {
  const dropdown = dropdownProperties[input.name];
  const dropdownSelectionId = event.currentTarget.value ? event.currentTarget.value : undefined;

  clearDropDowns(dropdown.toClear, model);
  disableDropdowns(dropdownSelectionId ? dropdown.toDisable : dropdown.toClear, model);

  if (dropdown.init && dropdownSelectionId) {
    dropdown.init(dropdownSelectionId, undefined, inputs, model, translations);
  }

  model.set(input.name, dropdownSelectionId);
};

export const onCheckboxChange = (input, model) => {
  model.set(input.name, filter(input.element, ','));
};

export const mapToModel = (name, element) => {
  return { name, element };
};

export const mapToEvent = (binding, func) => {
  return { binding, func };
};

const setUpFormatter = (formatter, separator) => {
  return (number) => {
    return formatter(number, separator);
  };
};

export const bindSearchElements = (model, inputs, events) => {
  const formatter = setUpFormatter(formatNumberWithThousandSeparator, '.');
  setUpSliderLabel(inputs.price, model, formatter);
  setUpSliderLabel(inputs.area, model);

  Object.values(events).forEach(({func, binding}) => func(binding, model));
};
